module.exports = __webpack_public_path__ + "5d5e72c2883aa45056aea602b3092c9c.fbx";